<template>
  <a-button type="link" @click="handleEventOpen">修改密码</a-button>
  <a-drawer
      v-model:open="openStatus"
      class="custom-class"
      root-class-name="root-class-name"
      :root-style="{ color: 'blue' }"
      title="修改密码"
      width="28%"
      @close="handleEventClose"
      placement="right"
      :destroy-on-close="true"
      :keyboard="false"
      :maskClosable="false"

  >


    <template #extra>
      <a-button style="margin-right: 8px" @click="handleEventClose">关闭</a-button>
      <a-button type="primary" :loading="submitting" @click="handleEventSubmit">提交</a-button>
    </template>

    <a-form
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item
              name="name"
              label="原密码"
              v-bind="validateInfos.old_password"
          >
            <a-input v-model:value="formState.old_password" placeholder="密码至少6个字符" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
              name="name"
              label="新密码"
              v-bind="validateInfos.new_password"
          >
            <a-input v-model:value="formState.new_password" placeholder="密码至少6个字符" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
              name="name"
              label="确认密码"
              v-bind="validateInfos.new_password2"
          >
            <a-input v-model:value="formState.new_password2" placeholder="密码至少6个字符" />
          </a-form-item>
        </a-col>



      </a-row>
    </a-form>


  </a-drawer>



</template>

<script setup>

import {Form, message} from "ant-design-vue";
import {reactive, ref, toRaw} from "vue";
import {updatePassword} from "@/api/common/personal";
const color = ref('#f56a00');
const size = ref(100);

const submitting = ref(false)
const useForm = Form.useForm;
const openStatus = ref(false)
const emits = defineEmits(['listenParentRefresh'])

const formState = reactive({
  old_password: '',
  new_password: '',
  new_password2: '',
});
const rulesRef = reactive({
  old_password: [
      {required: true, message: '请输密码',},
      {min: 6, message: '密码长度不能少于6个字符'}
  ],
  new_password: [
      {required: true, message: '请输密码',},
      {min: 6, message: '密码长度不能少于6个字符'}
  ],
  new_password2: [
      {required: true, message: '请输密码',},
      {min: 6, message: '密码长度不能少于6个字符'}
  ],
});
const {
  resetFields,
  validate,
  validateInfos,
} = useForm(formState, rulesRef, {
  onValidate: (...args) => console.log(...args),
});

//提交
const handleEventSubmit = async () => {
  if (submitting.value) return
  if (!await validate()) {
    return
  }
  submitting.value = true
  try {
    let params = formState
    console.log('提交参数',params);
    let res = await updatePassword(params)
    if (res.code === 200) {
      message.success(res.message)
      handleEventClose()
      //触发列表刷新
      emits('listenParentRefresh')
    }
  } finally {
    submitting.value = false
  }
}
const handleEventOpen = () => {
  openStatus.value = true
}
//关闭
const handleEventClose = () => {
  openStatus.value = false
  resetFields()
}


</script>

<style scoped>
.ant-btn-link{
  padding: 0 5px;
}
</style>